<section class="card-collection container py-5 lg:py-8">
  <div class="col-span-12 flex flex-col">
    <header class="card-collection__header">
      <h1 class="vtmn-title-4" aria-label="title">{{ title }}</h1>

      <nav *ngIf="isMobileDevice" class="card-collection__navigation">
        <button
          [id]="prevCardCollectionButtonId"
          app-vtmn-play-icon-button
          type="button"
          class="card-collection__navigation__button"
          [size]="vtmnPlayIconButtonSize.MEDIUM"
          [variant]="vtmnPlayButtonIconVariant.TERTIARY"
          [attr.aria-label]="'a11y.slider.button.next' | translate"
        >
          <vtmn-play-icon
            class="card-collection__navigation__button__icon"
            ariaLabel="'a11y.slider.button.previous' | translate"
            [name]="icon?.ArrowLeft"
          ></vtmn-play-icon>
        </button>
        <button
          [id]="nextCardCollectionButtonId"
          app-vtmn-play-icon-button
          type="button"
          class="card-collection__navigation__button"
          [size]="vtmnPlayIconButtonSize.MEDIUM"
          [variant]="vtmnPlayButtonIconVariant.TERTIARY"
          [attr.aria-label]="'a11y.slider.button.next' | translate"
        >
          <vtmn-play-icon
            class="card-collection__navigation__button__icon"
            ariaLabel="'a11y.slider.button.next' | translate"
            [name]="icon?.ArrowRight"
          ></vtmn-play-icon>
        </button>
      </nav>
    </header>

    <div
      *ngIf="description"
      class="card-collection__description"
      [innerHtml]="description | safeHtml"
    ></div>

    <ng-container *ngIf="cards?.length">
      <swiper *ngIf="isMobileDevice" [config]="config" [virtual]="true">
        <ng-template swiperSlide *ngFor="let card of cards">
          <ng-container [ngTemplateOutlet]="card.itemTemplate"></ng-container>
        </ng-template>
      </swiper>

      <ul
        *ngIf="!isMobileDevice"
        class="grid grid-cols-4 gap-x-3 gap-y-4 lg:gap-x-4"
      >
        <li *ngFor="let card of cards; let isFirst = first">
          <ng-container [ngTemplateOutlet]="card.itemTemplate"></ng-container>
        </li>
      </ul>
    </ng-container>

    <a
      *ngIf="showCta"
      app-vtmn-play-button
      class="mx-auto mt-6"
      [class.w-full]="isMobileDevice"
      [href]="linkUrl"
      [shape]="
        isMobileDevice
          ? vtmnPlayButtonShape.SQUARED
          : vtmnPlayButtonShape.ROUNDED
      "
    >
      {{ link.text }}
    </a>
  </div>
</section>
